module.exports = __webpack_public_path__ + "6af811ad106a7b93893299cffdc3792c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/components/TopMenu/icons/whatsapp-svg.svg
// module id = 1563
// module chunks = 0